var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled])';
export const useHandleFocus = (isFocusable) => {
    _react_refresh_temp_1();
    const ref = useRef(null);
    useEffect(() => {
        const cell = ref.current;
        if (!cell) {
            return;
        }
        const focusableChildren = cell.querySelectorAll(FOCUSABLE_SELECTOR);
        const [firstFocusableChild] = focusableChildren;
        if (!isFocusable) {
            cell.removeAttribute('tabindex');
            // Interactive cell content (buttons, checkboxes, links) is kept out
            // of the page tab sequence; it is reached through the table's arrow
            // navigation, never with Tab.
            focusableChildren.forEach((child) => {
                child.setAttribute('tabindex', '-1');
            });
            return;
        }
        if (firstFocusableChild) {
            // The active cell is the single tab stop: expose its content to the
            // tab sequence and move focus onto it.
            focusableChildren.forEach((child) => {
                child.setAttribute('tabindex', '0');
            });
            firstFocusableChild.focus();
        }
        else {
            cell.setAttribute('tabindex', '0');
            cell.focus();
        }
    }, [isFocusable]);
    return ref;
};
_react_refresh_temp_1(useHandleFocus, "8uVE59eA/r6b92xF80p7sH8rXLk=");
